<template>
  <div class="w-full">
    <div
      class="md:px-15"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
    >
      <search-bar
        name="searchBeneficiary"
        libelle=""
        :value="searchBeneficiary"
        placeholder="Rechercher un bénéficiaire"
        :big="false"
        @input="
          (newValue) => {
            searchBeneficiary = newValue;
          }
        "
      />
    </div>
    <div class="w-full space-y-5 mt-10">
      <div class="flex items-center space-x-2"
            :class="[isLoading && 'justify-center']"
      >
        <div
          v-if="isLoading"
          class="animate-spin w-5 h-5 border-t border-b rounded-full border-gray-900"
        />
        <div class="flex flex-col items-left"
        v-show="!isLoading"
        >
          <checkbox-indigo
            :name="'selectAllBeneficiaries'"
            :libelle="
              'Sélectionner tous les ' + totalNbBeneficiaries + ' bénéficiaires'
            "
            class="ml-1/12 md:ml-15"
            :value="filter.length == totalNbBeneficiaries"
            @input="selectAllBeneficiaries()"
          />
          <div
                  class="flex flex-row items-center gap-3"
                  v-for="group in groups"
                  :key="group.id"
          >
            <checkbox-indigo

              :name="'selectGroup'+group.id"
              :libelle="`Sélectionner le groupe ${group.name} (${group.users.length} bénéficiaires)`"
              class="ml-1/12 md:ml-15"
              :value="isGroupSelected(group)"
              @input="selectUserGroup(group)"
            >

            </checkbox-indigo>

            <ActionButton
                    border-color="border-transparent"
                    text-color="text-gray-900"
                    bg-color="bg-pink-300"
                    bg-color-square="bg-white"
                    icon-color="text-pink-600"
                    icon="trash"
                    :responsive="true"
                    libelle="Supprimer ce groupe"
                    @clickAction="deleteGroup(group)"
                    :is-disabled="group.name === undefined || group.name === ''"
            >
            </ActionButton>
          </div>

        </div>
      </div>
      <list-grid
        :list-items="beneficiaries"
        :is-listdisplayed="beneficiaries != null && beneficiaries.length > 0"
      >
        <template
          #header
          v-if="beneficiaries"
        >
          <div class="hidden md:block md:pl-15 col-span-3">
            Sélectionner
          </div>
          <div class="md:hidden md:pl-15 col-span-3 text-center">
            Sél.
          </div>
          <div class="col-span-9 md:col-span-5">
            Bénéficiaires
          </div>
          <div class="hidden md:block md:col-span-4">
            {{ filter.length }} bénéficiaire{{
              filter.length > 1 ? 's' : ''
            }}
            sélectionné{{ filter.length > 1 ? 's' : '' }}
          </div>
        </template>

        <template #errorCases>
          <div
            v-if="beneficiaries && beneficiaries.length === 0"
            class="flex flex-col justify-center items-center w-full my-8"
          >
            <div class="text-pink-600 text-center text-lg mb-8">
              Aucun bénéficiaire !
            </div>
            <div class="text-indigo-600 text-center text-base mb-8">
              Il n'y a aucun bénéficiaire trouvé
            </div>
            <div>
              <illustration name="no_result" />
            </div>
          </div>
        </template>

        <!-- BEGIN list of beneficiaries -->
        <template #accordionDescription="{ item, num }">
          <div
            class="col-span-3 md:pl-15 cursor-pointer flex justify-center md:block md:justify-start"
            @click.stop="selectBeneficiary(item)"
          >
            <checkbox-indigo
              :name="'selectBeneficiary' + item.id"
              :value="filteredBeneficiariesIds.includes(item.id)"
              @input="selectBeneficiary(item)"
            />
          </div>
          <div
            class="col-span-9 cursor-pointer"
            @click.stop="selectBeneficiary(item)"
          >
            {{ item.firstname }} {{ item.lastname }}
          </div>
        </template>
        <!-- END list of beneficiaries -->
      </list-grid>
      <!-- BEGIN Links for pagination -->
      <div
        v-if="beneficiaries.length > 0"
        class="w-full flex items-center justify-center"
      >
        <div class="w-full md:w-1/2 flex items-center justify-center space-x-5">
          <div @click.stop="getToPreviousPage">
            <icon
              name="chevron-left"
              class="p-2 w-8 h-8 rounded-full"
              :class="{
                'bg-gray-600 text-white': selectedPage === 1,
                'bg-pink-600 text-white cursor-pointer transform hover:scale-110 duration-300':
                  selectedPage !== 1,
              }"
            />
          </div>
          <div class="flex flex-wrap items-center justify-center w-full">
            <div
              class="p-3 w-8 h-8 rounded-full flex justify-center items-center cursor-pointer transform hover:scale-110 duration-300"
              :class="{
                'bg-pink-600 text-white': pageNumber === selectedPage,
              }"
              v-for="pageNumber in pages"
              :key="'pageNumber' + pageNumber"
              @click="selectedPage = pageNumber"
            >
              {{ pageNumber }}
            </div>
          </div>
          <div @click.stop="getToNextPage">
            <icon
              name="chevron-right"
              class="p-2 w-8 h-8 rounded-full"
              :class="{
                'bg-gray-600 text-white': selectedPage == lastPage,
                'bg-pink-600 text-white cursor-pointer transform hover:scale-110 duration-300':
                  selectedPage != lastPage,
              }"
            />
          </div>
        </div>
      </div>
      <!-- END Links for pagination -->
    </div>
  </div>
</template>

<script>
import axios from './../../../api';
import ListGrid from '../../../components/AccordionTable/ListGrid.vue';
import SearchBar from '../../../components/Inputs/SearchBar.vue';
import CheckboxIndigo from '../../../components/Inputs/CheckboxIndigo.vue';
import Icon from '../../../components/Icon.vue';
import Illustration from '../../../components/Illustration.vue';
import ActionButton from "../../../components/ActionButton.vue";

export default {
  components: {
    ActionButton,
    SearchBar,
    ListGrid,
    CheckboxIndigo,
    Icon,
    Illustration,
  },

  props: {
    filter: Array,
    groups: Array,
  },

  data() {
    return {
      beneficiaries: [],
      searchBeneficiary: '',
      selectedPage: 1,
      lastPage: 1,
      isLoading: false,
      searchTypingInterval: 500,
      perPage: 10,
      totalNbBeneficiaries: 0,
    };
  },

  mounted() {
    this.loadBeneficiariesList();
  },

  methods: {
    onKeyDown() {
      clearTimeout(this.timer);
    },

    onKeyUp() {
      clearTimeout(this.timer);
      this.timer = setTimeout(
        this.loadBeneficiariesList,
        this.searchTypingInterval
      );
    },

    async deleteGroup(group) {
      await axios.delete(`api/userGroups/${group.id}`);
      this.$emit('groupDeleted');
    },

    loadBeneficiariesList() {
      console.log('wait..Module competences load beneficiaries');
      /** datas for Front version /
      this.listBeneficiaries = ConstantsCompetences.beneficiaries.sort(
        function (a, b) {
          if (a.lastname < b.lastname) {
            return -1;
          }
          if (a.lastname > b.lastname) {
            return 1;
          }
          return 0;
        }
      );
      /**/
      /* Keep it for final version */
      this.isLoading = true;
      try {
        axios
          .post(
            'api/loadBeneficiaries?paginated=' +
              0 +
              '&page=' +
              this.selectedPage +
              '&cursor=',
            {
              search: this.searchBeneficiary,
              orderBy: 'lastname',
              direction: 'ASC',
              perPage: this.perPage,
            }
          )
          .then((response) => {
            this.beneficiaries = response.data.beneficiaries;
            this.lastPage = response.data.lastPage;
            this.totalNbBeneficiaries = response.data.total;
            if (this.selectedPage > this.lastPage) {
              this.selectedPage = this.lastPage;
            }
            this.isLoading = false;
          });
      } catch (err) {
        console.error('ERROR::', err);
        this.isLoading = false;
      }
    },

    deleteBeneficiary(beneficiary) {
      let filter = [...this.filter];
      filter = filter.filter((b) => b.id != beneficiary.id);
      this.updateFilter(filter);
    },

    selectBeneficiary(beneficiary) {
      if (this.filteredBeneficiariesIds.includes(beneficiary.id)) {
        this.deleteBeneficiary(beneficiary);
        return;
      }

      let filter = [...this.filter];
      filter.push(beneficiary);
      this.updateFilter(filter);
    },

    updateFilter(filter) {
      this.$emit('updateBeneficiariesFilter', filter);
    },

    selectAllBeneficiaries() {
      if (this.filter.length == this.totalNbBeneficiaries) {
        this.updateFilter([]);
      } else {
        this.isLoading = true;
        try {
          axios
            .post('api/loadBeneficiaries?paginated=' + 0 + '&cursor=', {
              search: this.searchBeneficiary,
              orderBy: 'lastname',
              direction: 'ASC',
            })
            .then((response) => {
              let beneficiaries = response.data.beneficiaries;
              this.updateFilter([...beneficiaries]);
              this.isLoading = false;
            });
        } catch (err) {
          console.error('ERROR::', err);
          this.isLoading = false;
        }
      }
    },

    selectUserGroup(group) {
      if (this.isGroupSelected(group)) {
        this.updateFilter([]);
      } else {
        this.updateFilter([...group.users]);
      }
    },

    isGroupSelected(group) {
      if (this.filter.length !== group.users.length) {
        return false;
      }

      const filterIds = this.filter.map(u => u.id);
      const groupIds = group.users.map(u => u.id);

      filterIds.sort();
      groupIds.sort();

      const match = [group.users.length];

      for (let i = 0; i < filterIds.length; i++) {
        const filterId =  filterIds[i];
        const groupId = groupIds[i];

        match[i] = filterId === groupId;
      }

      return match.reduce((acc, curr) => {
        return acc && curr;
      }, true);
    },

    getToPreviousPage() {
      if (this.selectedPage === 1) {
        return;
      }

      this.selectedPage = this.selectedPage - 1;
    },

    getToNextPage() {
      if (this.selectedPage === this.lastPage) {
        return;
      }

      this.selectedPage = this.selectedPage + 1;
    },
  },
  computed: {
    pages() {
      let pages = [];

      for (let index = 1; index <= this.lastPage; index++) {
        pages.push(index);
      }
      return pages;
    },
    filteredBeneficiariesIds() {
      return this.filter.map((beneficiary) => beneficiary.id);
    },
  },

  watch: {
    selectedPage() {
      this.loadBeneficiariesList();
    },
  },
};
</script>
